module.exports = __webpack_public_path__ + "img/no-information.cc395fe1.png";